<template>
  <div id="footer">
    <div class="footer text-light body-4">
      <div class="background bg-1"/>
      <div class="top flex justify-space-between align-center">
        <div class="address flex flex-column">
          <span class="body-3">Imperatriz - MA</span>
          <span>BR 010 km 1357, Quadra - B,</span>
          <span>Lote 22, Distrito Industrial</span>
          <span>65.917-220</span>
        </div>
        <div class="contacts flex-column">
          <span v-if="safeConfig.phone">{{ safeConfig.phone }}</span>
          <span v-if="safeConfig.phone2">{{ safeConfig.phone2 }}</span>
          <span class="body-3" v-if="safeConfig.email">{{ safeConfig.email }}</span>
        </div>
        <div class="routes flex-column" v-if="windowWidth > 790">
          <router-link v-for="(route, index) in firstColumnRoutes" :key="index" :to="route.route">
            {{ route.text }}
          </router-link>
        </div>
        <div class="routes flex-column" v-if="windowWidth > 790">
          <router-link v-for="(route, index) in secondColumnRoutes" :key="index" :to="route.route">
            {{ route.text }}
          </router-link>
          <a href="http://www.grupotopazio.com.br/" target="_blank">Blog</a>
        </div>
      </div>
      <div class="bottom flex justify-space-between align-center">
        <div class="copyright">Copyright {{ new Date().getFullYear() }} © Grupo Topázio</div>
        <div class="social flex align-center justify-space-between">
          <a href="https://www.facebook.com/grupotopazioo/" target="_blank">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g opacity="0.7">
                <path d="M2.0555 23C1.9165 22.9996 1.77893 22.9718 1.65066 22.9183C1.52239 22.8647 1.40592 22.7864 1.30791 22.6879C1.2099 22.5893 1.13226 22.4724 1.07943 22.3438C1.0266 22.2152 0.99961 22.0775 1 21.9385V2.0615C1 1.475 1.4725 1 2.0555 1H21.945C22.5275 1 23 1.475 23 2.0615V21.9385C23.0004 22.0775 22.9734 22.2152 22.9206 22.3438C22.8677 22.4724 22.7901 22.5893 22.6921 22.6879C22.5941 22.7864 22.4776 22.8647 22.3493 22.9183C22.2211 22.9718 22.0835 22.9996 21.9445 23H2.055H2.0555Z" stroke="#FAFAFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M19.3305 8.9435H16.8965C16.5724 8.9435 16.2616 9.07224 16.0324 9.30141C15.8033 9.53058 15.6745 9.8414 15.6745 10.1655V12.6105H19.3305L18.7955 16.2765H15.6745V23H11.653V16.2765H8.33301V12.611H11.6105L11.653 9.1315L11.641 7.8845C11.637 7.46322 11.7165 7.04532 11.8749 6.65494C12.0333 6.26457 12.2676 5.90946 12.564 5.61014C12.8605 5.31083 13.2134 5.07323 13.6022 4.91109C13.9911 4.74895 14.4082 4.66548 14.8295 4.6655H19.3305V8.9435Z" fill="#FAFAFA"/>
              </g>
            </svg>
          </a>
          <a href="https://www.instagram.com/grupotopazio_/" target="_blank">
            <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g opacity="0.7">
                <path d="M14.4998 19.3333C15.7817 19.3333 17.0111 18.8241 17.9175 17.9177C18.8239 17.0112 19.3332 15.7819 19.3332 14.5C19.3332 13.2181 18.8239 11.9887 17.9175 11.0823C17.0111 10.1759 15.7817 9.66666 14.4998 9.66666C13.218 9.66666 11.9886 10.1759 11.0822 11.0823C10.1757 11.9887 9.6665 13.2181 9.6665 14.5C9.6665 15.7819 10.1757 17.0112 11.0822 17.9177C11.9886 18.8241 13.218 19.3333 14.4998 19.3333V19.3333Z" stroke="#FAFAFA" stroke-width="1.8125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M3.625 19.3333V9.66667C3.625 8.06432 4.26153 6.5276 5.39456 5.39456C6.5276 4.26153 8.06432 3.625 9.66667 3.625H19.3333C20.9357 3.625 22.4724 4.26153 23.6054 5.39456C24.7385 6.5276 25.375 8.06432 25.375 9.66667V19.3333C25.375 20.9357 24.7385 22.4724 23.6054 23.6054C22.4724 24.7385 20.9357 25.375 19.3333 25.375H9.66667C8.06432 25.375 6.5276 24.7385 5.39456 23.6054C4.26153 22.4724 3.625 20.9357 3.625 19.3333Z" stroke="#FAFAFA" stroke-width="1.8125"/>
                <path d="M21.146 7.86577L21.1577 7.85294" stroke="#FAFAFA" stroke-width="1.8125" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
            </svg>
          </a>
          <a href="https://www.linkedin.com/company/grupotop%C3%A1zio/" target="_blank">
            <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g opacity="0.7">
                <path d="M24.0071 3.17188H4.99287C3.9875 3.17188 3.17188 3.9875 3.17188 4.99287V24.0071C3.17188 25.0125 3.9875 25.8281 4.99287 25.8281H24.0071C25.0125 25.8281 25.8281 25.0125 25.8281 24.0071V4.99287C25.8281 3.9875 25.0125 3.17188 24.0071 3.17188ZM24.0071 24.0156C11.3253 24.0128 4.98438 24.01 4.98438 24.0071C4.98721 11.3253 4.99004 4.98438 4.99287 4.98438C17.6747 4.98721 24.0156 4.99004 24.0156 4.99287C24.0128 17.6747 24.01 24.0156 24.0071 24.0156ZM6.53066 11.6651H9.89228V22.4778H6.53066V11.6651ZM8.21289 10.1868C9.28623 10.1868 10.1613 9.31455 10.1613 8.23838C10.1613 7.98251 10.1109 7.72914 10.013 7.49274C9.91509 7.25635 9.77157 7.04155 9.59064 6.86063C9.40972 6.6797 9.19492 6.53618 8.95853 6.43826C8.72213 6.34034 8.46876 6.28994 8.21289 6.28994C7.95702 6.28994 7.70365 6.34034 7.46726 6.43826C7.23086 6.53618 7.01607 6.6797 6.83514 6.86063C6.65421 7.04155 6.51069 7.25635 6.41277 7.49274C6.31485 7.72914 6.26445 7.98251 6.26445 8.23838C6.26162 9.31455 7.13389 10.1868 8.21289 10.1868ZM15.3581 17.1281C15.3581 15.7178 15.6271 14.3527 17.3745 14.3527C19.0964 14.3527 19.1219 15.9642 19.1219 17.2188V22.4778H22.4807V16.5476C22.4807 13.6362 21.852 11.3961 18.4507 11.3961C16.8166 11.3961 15.7206 12.2938 15.2703 13.1435H15.225V11.6651H11.9993V22.4778H15.3581V17.1281Z" fill="#FAFAFA"/>
              </g>
            </svg>
          </a>
          <a href="https://www.youtube.com/channel/UCch19izIK9ziC4bgLAt2Wog" target="_blank">
            <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g opacity="0.7">
                <path d="M29.0625 15.4152C29.0625 15.3486 29.0625 15.2729 29.0595 15.1851C29.0564 14.9399 29.0504 14.6644 29.0443 14.3708C29.0201 13.5262 28.9777 12.6846 28.9111 11.8914C28.8203 10.7985 28.6871 9.8873 28.5055 9.20312C28.3138 8.48912 27.9381 7.83793 27.4158 7.31465C26.8936 6.79137 26.2432 6.41432 25.5296 6.22119C24.6729 5.99111 22.9957 5.84882 20.6344 5.76103C19.5112 5.71865 18.3094 5.6914 17.1075 5.67626C16.6867 5.67021 16.2962 5.66718 15.945 5.66415H15.055C14.7038 5.66718 14.3133 5.67021 13.8925 5.67626C12.6906 5.6914 11.4888 5.71865 10.3656 5.76103C8.0043 5.85185 6.32412 5.99413 5.47041 6.22119C4.75657 6.41384 4.10589 6.79074 3.5836 7.31409C3.06131 7.83745 2.68574 8.48888 2.49453 9.20312C2.30986 9.8873 2.17969 10.7985 2.08887 11.8914C2.02227 12.6846 1.97988 13.5262 1.95566 14.3708C1.94658 14.6644 1.94355 14.9399 1.94053 15.1851C1.94053 15.2729 1.9375 15.3486 1.9375 15.4152V15.5848C1.9375 15.6514 1.9375 15.727 1.94053 15.8148C1.94355 16.0601 1.94961 16.3355 1.95566 16.6292C1.97988 17.4738 2.02227 18.3154 2.08887 19.1086C2.17969 20.2015 2.31289 21.1127 2.49453 21.7969C2.88203 23.247 4.02031 24.3913 5.47041 24.7788C6.32412 25.0089 8.0043 25.1512 10.3656 25.239C11.4888 25.2813 12.6906 25.3086 13.8925 25.3237C14.3133 25.3298 14.7038 25.3328 15.055 25.3358H15.945C16.2962 25.3328 16.6867 25.3298 17.1075 25.3237C18.3094 25.3086 19.5112 25.2813 20.6344 25.239C22.9957 25.1481 24.6759 25.0059 25.5296 24.7788C26.9797 24.3913 28.118 23.25 28.5055 21.7969C28.6901 21.1127 28.8203 20.2015 28.9111 19.1086C28.9777 18.3154 29.0201 17.4738 29.0443 16.6292C29.0534 16.3355 29.0564 16.0601 29.0595 15.8148C29.0595 15.727 29.0625 15.6514 29.0625 15.5848V15.4152ZM26.8828 15.5726C26.8828 15.6362 26.8828 15.7059 26.8798 15.7876C26.8768 16.0237 26.8707 16.2841 26.8646 16.5656C26.8435 17.3709 26.8011 18.1762 26.7375 18.9239C26.6558 19.8987 26.5407 20.6979 26.3984 21.2338C26.2107 21.9331 25.6598 22.4871 24.9635 22.6718C24.3277 22.8413 22.7263 22.9775 20.5496 23.0593C19.4477 23.1017 18.2609 23.1289 17.0772 23.144C16.6625 23.1501 16.278 23.1531 15.9329 23.1531H15.0671L13.9228 23.144C12.7391 23.1289 11.5554 23.1017 10.4504 23.0593C8.27373 22.9745 6.66924 22.8413 6.03652 22.6718C5.34023 22.4841 4.78926 21.9331 4.60156 21.2338C4.45928 20.6979 4.34424 19.8987 4.2625 18.9239C4.19893 18.1762 4.15957 17.3709 4.13535 16.5656C4.12627 16.2841 4.12324 16.0207 4.12021 15.7876C4.12021 15.7059 4.11719 15.6332 4.11719 15.5726V15.4273C4.11719 15.3638 4.11719 15.2941 4.12021 15.2124C4.12324 14.9763 4.1293 14.7159 4.13535 14.4344C4.15654 13.6291 4.19893 12.8238 4.2625 12.0761C4.34424 11.1013 4.45928 10.302 4.60156 9.7662C4.78926 9.06689 5.34023 8.51288 6.03652 8.32822C6.67227 8.15869 8.27373 8.02245 10.4504 7.94072C11.5523 7.89833 12.7391 7.87109 13.9228 7.85595C14.3375 7.8499 14.722 7.84687 15.0671 7.84687H15.9329L17.0772 7.85595C18.2609 7.87109 19.4446 7.89833 20.5496 7.94072C22.7263 8.02548 24.3308 8.15869 24.9635 8.32822C25.6598 8.51591 26.2107 9.06689 26.3984 9.7662C26.5407 10.302 26.6558 11.1013 26.7375 12.0761C26.8011 12.8238 26.8404 13.6291 26.8646 14.4344C26.8737 14.7159 26.8768 14.9793 26.8798 15.2124C26.8798 15.2941 26.8828 15.3668 26.8828 15.4273V15.5726ZM12.8057 19.5566L19.8291 15.4697L12.8057 11.4434V19.5566Z" fill="#FAFAFA"/>
              </g>
            </svg>
          </a>
        </div>
      </div>
      <div class="developer-credit-standard flex align-center justify-center">
        <span class="text-xs">Desenvolvido por</span>
        <a
          href="https://juliodevelop.online"
          target="_blank"
          rel="noopener noreferrer"
          class="flex align-center"
        >
          <img
            src="/juliodevelop-logo.png"
            alt="JulioDevelop"
            class="developer-logo-standard"
          />
          <span class="text-xs">JulioDevelop</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Footer',
  data () {
    return {
      windowWidth: window.innerWidth,
      // Rotas estáticas (primeiras 5 rotas do footer)
      staticRoutes: [
        { text: 'Nossa História', route: 'nossa-historia' },
        { text: 'A Topázio', route: 'a-topazio' },
        { text: 'Ser um afiliado', route: 'ser-um-afiliado' },
        { text: 'Representantes', route: 'representantes' },
        { text: 'Fale Conosco', route: 'fale-conosco' }
      ]
    }
  },
  computed: {
    ...mapGetters(['productCategories', 'siteConfig']),
    // Config com fallback seguro
    safeConfig () {
      return this.siteConfig || {}
    },
    // Combina rotas estáticas com categorias dinâmicas da API (vazio se não retornar)
    routes () {
      const categories = Array.isArray(this.productCategories) ? this.productCategories : []
      const validCategories = categories.filter(cat => cat && cat.name && cat.slug)
      const productRoutes = validCategories.map(cat => ({
        text: cat.name,
        route: cat.slug
      }))
      return [...this.staticRoutes, ...productRoutes]
    },
    // Primeira coluna de rotas (primeiras 5)
    firstColumnRoutes () {
      return this.routes.slice(0, 5)
    },
    // Segunda coluna de rotas (restante, max 4)
    secondColumnRoutes () {
      return this.routes.slice(5, 9)
    }
  },
  mounted () {
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/_colors.scss';

.footer {
  margin-top: 70px;
  padding: 20px 70px;
  min-height: 180px;
  position: relative;
  .top {
    margin-bottom: 35px;
  }
  .address, .contacts, .routes {
    text-align: left;
  }
  .address {
    max-width: 270px;
  }
  .social svg {
    margin-left: 10px;
    opacity: .7;
    transition: all .2s ease;
    cursor: pointer;
  }
  .social svg:hover {
    opacity: 1;
  }
  a {
    color: map-get($mainColors , 'light' );
    text-decoration: none;
    opacity: .6;
    transition: all .3s ease;
  }
  a:hover {
    opacity: 1;
  }
  .developer-credit {
    gap: 8px;
    opacity: .6;
    transition: all .3s ease;
    &:hover {
      opacity: 1;
    }
    .developer-logo {
      height: 28px;
      width: auto;
    }
  }
  .developer-credit-standard {
    margin-top: 32px;
    padding-top: 24px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    gap: 8px;
    .text-xs {
      font-size: 12px;
      color: rgba(255, 255, 255, 0.5);
    }
    a {
      display: flex;
      align-items: center;
      gap: 6px;
      transition: opacity 0.3s ease;
      &:hover {
        opacity: 0.8;
      }
    }
    .developer-logo-standard {
      width: 20px;
      height: 20px;
    }
  }
}
.footer .background {
  position: absolute;
  bottom: -48px;
  left: -7vw;
  z-index: -1;
  width: 115vw;
  height: calc(100% + 120px);
  min-height: 300px;
  border-radius: 50% 50% 0 0 / 8% 8% 0 0;
  transform: rotate(-3.5deg);
}
@media screen and (max-width: 525px) {
  .footer {
    padding: 20px 20px;
    .bottom {
      flex-direction: column-reverse;
      .social {
        margin: -10px 0 10px 0;
      }
    }
  }
}
@media screen and (max-width: 440px){
  .footer {
    .top {
      flex-direction: column;
      .address, .contacts {
        text-align: center;
      }
      .address {
        margin-top: -30px;
        margin-bottom: 10px;
      }
    }
  }
  .footer .background {
    height: calc(100% + 160px);
  }
}
</style>